import { render } from "./SenderView.vue?vue&type=template&id=31d56027&lang=html"
import script from "./SenderView.vue?vue&type=script&lang=js"
export * from "./SenderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__